module.exports = __webpack_public_path__ + "static/2_1_search-2_CS-0f3aabcc450ba4e6e6dd7b94e8524a11.svg";